<template>
  <div>
    <BubbleParamSlider
      :param-object="paramObject"
      :disabled="auto"
      class="mb-0"
    />
    <LabelledInput>
      <b-checkbox v-model="auto">
        Automatic minimum size
      </b-checkbox>
    </LabelledInput>
  </div>
</template>

<script lang="ts">

import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import BubbleParamSlider, { BubbleParams } from '@/components/builder/BubbleParams/BubbleParamSlider.vue'

const components = {
  LabelledInput,
  BubbleParamSlider,
}

const props = {
  paramObject: {
    type: Object as PropType<BubbleParams>,
    default: () => ({
      name: '',
      label: '',
      min: 0,
      max: 1000,
      step: 1,
      description: '',
    }),
  },
}

@Component({ components })
export default class BubbleMinSlider extends Vue.extend({ props }) {
  get auto () {
    return this.$typedStore.primary.app.config.bubbleParams.bubbleMinAuto
  }

  set auto (newValue) {
    this.$typedStore.visualisationApp.updateBubbleParams({
      param: 'bubbleMinAuto',
      value: newValue,
    })
  }
}

</script>
